import type { ItemStoreState } from "@editor/items/ItemStore";
import type { TargetItem } from "@editor/items/target/TargetItem";
import type { ResourceItem } from "@editor/items/resource/ResourceItem";

export default {
  applyToVersions: "<2.7.0",
  type: "before",
  name: "remove the old standard background colors of elements and resources",
  migrate(data: {
    elements: ItemStoreState<TargetItem>;
    resources: ItemStoreState<ResourceItem>;
  }) {
    if (data.elements) {
      for (const element of Object.values(data.elements.items)) {
        if (
          element.backgroundColor &&
          element.backgroundColor.toLowerCase() === "#ffffff"
        ) {
          element.backgroundColor = null;
        }
      }
    }

    if (data.resources) {
      for (const resource of Object.values(data.resources.items)) {
        if (
          resource.backgroundColor &&
          resource.backgroundColor.toLowerCase() === "#ffffff"
        ) {
          resource.backgroundColor = null;
        }
      }
    }

    return data;
  }
};
